import { atom } from 'jotai';
import { FeedConfig } from '../types';

export const feedsInDisplayAtom = atom<FeedConfig[]>([]);
